export const AppActionConstants = {
	storeContextValues: "STORECONTEXTVALUES",
	// fetch: 'FETCH',
	addAllAarcValues: "ADDALLAARCVALUES",
	fetchCampaigns: "FETCHCAMPAIGNS",
	fetchConfigAndPlatforms: "FETCHCONFIGANDPLATFORMS",
	fetchSheet: "FETCHSHEET",
	fetchActivationHeaders: "FETCHACTIVATIONHEADERS",
	fetchAuditLevelConfig: "FETCHAUDITLEVELCONFIG",
	fetchPackages: "FETCHPACKAGES",
	fetchOnlyPackages: "FETCHONLYPACKAGES",
	fetchPlacements: "FETCHPLACEMENTS",
	fetchPlacementConfig: "FETCHPLACEMENTCONFIG",
	fetchOnlyPlacements: "FETCHONLYPLACEMENTS",
	fetchAdSet: "FETCHADSET",
	setFilteredAdSets: "SETFILTEREDADSETS",
	fetchParentData: "FETCHPARENTDATA",
	fetchCreatives: "FETCHCREATIVES",
	putFilters: "PUTFILTERS",
	putPlacementDataSuccess: "PUTPLACEMENTDATASUCCESS",
	addPlacementDataFail: "ADDPLACEMENTDATAFAIL",
	putPlacementDataFail: "PUTPLACEMENTDATAFAIL",
	holdMasterCampaignUniqueID: "HOLDMASTERCAMPAIGNUNIQUEID",
	putCampaignUniqueID: "PUTCAMPAIGNUNIQUEID",
	editCampaignDataSuccess: "EDITCAMPAIGNSUCESS",
	editCampaignDataFail: "EDITCAMPAIGNFAIL",
	updateAdSetSuccess: "UPDATEADSETSUCCESS",
	updateAdSetFail: "UPDATEADSETFAIL",
	editAdSetSuccess: "EDITADSETSUCCESS",
	editAdSetFail: "EDITADSETFAIL",
	createAndAddAdSetSuccess: "CREATEANDADDADSETSUCCESS",
	updateCampaignDataSuccess: "UPDATECAMPAIGNDATASUCCESS",
	updateCampaignDataFail: "UPDATECAMPAIGNDATAFAIL",
	updatePlacementDataSuccess: "UPDATEPLACEMENTDATASUCCESS",
	updatePlacementDataFail: "UPDATEPLACEMENTDATAFAIL",
	updatePlacementData: "UPDATEPLACEMENTDATA",
	createAndAddChildSuccess: "CREATEANDADDCHILDSUCCESS",
	updateClientConfig: "UPDATECLIENTCONFIG",
	updateActivationDataSuccess: "UPDATEACTIVATIONDATASUCCESS",
	updateActivationDataFail: "UPDATEACTIVATIONDATAFAIL",
	editActivationDataSuccess: "EDITACTIVATIONDATASUCCESS",
	editActivationDataFail: "EDITACTIVATIONDATAFAIL",
	createPackagesSuccess: "CREATEPACKAGESSUCCESS",
	createPackagesFail: "CREATEPACKAGESFAIL",
	editPackageSuccess: "EDITPACKAGESUCCESS",
	editPackageFail: "EDITPACKAGEFAIL",
	updateCreativesSuccess: "UPDATECREATIVESSUCCESS",
	updateCreativesFail: "UPDATECREATIVESFAIL",
	createAndAddCreativeSuccess: "CREATEANDADDCREATIVESUCCESS",
	editCreativesSuccess: "EDITCREATIVESSUCCESS",
	editCreativesFail: "EDITCREATIVESFAIL",
	deletePlacementSuccess: "DELETEPLACEMENTSUCCESS",
	deletePlacementFail: "DELETEPLACEMENTFAIL",
	fetchWorkbookMetaData: "FETCHWORKBOOKMETADATA",
	fetchWorkbookActivationCampaigns: "FETCHWORKBOOKACTIVATIONCAMPAIGNS",

	fetchInsertionOrders: "FETCHINSERTIONORDERS",
	fetchOnlyInsertionOrders: "FETCHONLYINSERTIONORDERS",
	createInsertionOrderSuccess: "CREATEINSERTIONORDERSUCCESS",
	createAndAddInsertionOrderSuccess: "CREATEANDADDINSERTIONORDERSUCCESS",
	createInsertionOrderFail: "CREATEINSERTIONORDERFAIL",
	editInsertionOrderSuccess: "EDITINSERTIONORDERSUCCESS",
	editInsertionOrderFail: "EDITINSERTIONORDERFAIL",
	setFilteredInsertionOrders: "SETFILTEREDINSERTIONORDERS",
	updateIOSyncStatus: "UPDATEIOSYNCSTATUS",
	createChildLineItems: "CREATECHILDLINEITEMS",

	fetchLineItems: "FETCHLINEITEMS",
	fetchOnlyLineItems: "FETCHONLYLINEITEMS",
	fetchOnlyLineItemsConfig: "FETCHONLYLINEITEMSCONFIG",
	createLineItemSuccess: "CREATELINEITEMSUCCESS",
	createAndAddLineItemSuccess: "CREATEANDADDLINEITEMSUCCESS",
	createLineItemFail: "CREATELINEITEMFAIL",
	editLineItemSuccess: "EDITLINEITEMSUCCESS",
	editLineItemFail: "EDITLINEITEMFAIL",
	setFilteredLineItems: "SETFILTEREDLINEITEMS",
	setFilterIO: "SETFILTERIO",
	triggerLineItemModal: "TRIGGERLINEITEMMODAL",
	childLineItemsSuccess: "CHILDLINEITEMSSUCCESS",
	childLineItemsFail: "CHILDLINEITEMSFAIL",
	updateLineItemsSyncStatus: "UPDATELINEITEMSSYNCSTATUS",

	packageUpdated: "PACKAGEUPDATED",
	addPackage: "ADDPACKAGE",

	deletePackageSuccess: "DELETEPACKAGESUCCESS",

	deleteAdSet: "DELETEADSET",
	deleteCreative: "DELETECREATIVE",
	deleteInsertionOrderSuccess: "DELETEINSERTIONORDERSUCCESS",
	deleteChildLineItems: "DELETECHILDLINEITEMS",
	deleteLineItem: "DELETELINEITEM",

	fetchCurrencySymbols: "FETCHCURRENCYSYMBOLS",
	setFilteredPlacements: "SETFILTEREDPLACEMENTS",
	setFilterPackage: "SETFILTERPACKAGE",

	packageCreated: "PACKAGECREATED",
	placementCreated: "PLACEMENTCREATED",
	placementFailed: "PLACEMENTFAILED",
	triggerPlacementModal: "TRIGGERPLACEMENTMODAL",

	validationFetched: "VALIDATIONFETCHED",
	advertisersFetched: "ADVERTISERSFETCHED",
	placementAPIConfigFetched: "PLACEMENTAPICONFIGFETCHED",
	placementSyncSuccess: "PLACEMENTSYNCSUCCESS",
	placementSyncFail: "PLACEMENTSYNCFAIL",

	advertiserCreatedSuccess: "ADVERTISERCREATEDSUCCESS",
	advertiserCreatedBulkSuccess: "ADVERTISERCREATEDBULKSUCCESS",
	advertiserCreatedFail: "ADVERTISERCREATEDFAIL",
	advertiserCreatedBulkFail: "ADVERTISERCREATEDBULKFAIL",
	advertiserUpdatedSuccess: "ADVERTISERUPDATEDSUCCESS",
	advertiserUpdatedBulkSuccess: "ADVERTISERUPDATEDBULKSUCCESS",
	advertiserUpdatedFail: "ADVERTISERUPDATEDFAIL",
	advertiserUpdatedBulkFail: "ADVERTISERUPDATEDBULKFAIL",

	getPlatformAdvertisers: "GETPLATFORMADVERTISERS",

	duplicateInsertionOrder: "DUPLICATEINSERTIONORDER",
	duplicateCreative: "DUPLICATECREATIVE",
	duplicateLineItem: "DUPLICATELINEITEM",
	duplicateAdSet: "DUPLICATEADSET",

	duplicateInsertionOrderFail: "DUPLICATEINSERTIONORDERFAIL",
	duplicateCreativeFail: "DUPLICATECREATIVEFAIL",
	duplicateLineItemFail: "DUPLICATELINEITEMFAIL",
	duplicateAdSetFail: "DUPLICATEADSETFAIL",

	duplicateActivationCampaignSuccessClose: "DUPLICATEACTIVATIONCAMPAIGNSUCCESSCLOSE",
	duplicateActivationCampaignSuccessOpen: "DUPLICATEACTIVATIONCAMPAIGNSUCCESSOPEN",
	duplicateActivationCampaignFail: "DUPLICATEACTIVATIONCAMPAIGNFAIL",

	fetchSideNav: "FETCH_SIDENAV",
	dataKeyDataValueFilters: "DATAKEYDATAVALUEFILTERS",

	archiveMasterCampaignSuccess: "ARCHIVE_MASTER_CAMPAIGN_SUCCESS",
	archiveMasterCampaignFail: "ARCHIVE_MASTER_CAMPAIGN_FAIL",

	archiveActivationCampaignSuccess: "ARCHIVE_ACTIVATION_CAMPAIGN_SUCCESS",
	archiveActivationCampaignFail: "ARCHIVE_ACTIVATION_CAMPAIGN_FAIL",
	bulkArchiveCampaignSuccess: "BULK_ARCHIVE_CAMPAIGN_SUCCESS",

	resetARCValues: "RESET_ARC_VALUES",
	fetchTaxonomyChangelog: "FETCH_TAXONOMY_CHANGELOG",
	fetchCampaignChangelog: "FETCH_CAMPAIGN_CHANGELOG",

	copyCampaignSuccess: "COPY_CAMPAIGN_SUCCESS",

	packagesSheetSuccess: "PACKAGES_SHEET_SUCCESS",
	packagesSheetFail: "PACKAGES_SHEET_FAIL",

	refetchPlacementsSuccess: "REFETCH_FLACEMENTS_SUCCESS",
	refetchPlacementsFail: "REFETCH_PLACEMENTS_FAIL",

	getTraffickingCampaigns: "GET_TRAFFICKING_CAMPAIGNS",
	getTraffickingPlacements: "GET_TRAFFICKING_PLACEMENTS",
	fetchAuditLevels: "FETCH_AUDIT_LEVELS",
	rejectTraffickingSuccess: "REJECT_TRAFFICKING_SUCCESS",
	rejectTraffickingFail: "REJECT_TRAFFICKING_FAIL",
	approveTraffickingSuccess: "APPROVE_TRAFFICKING_SUCCESS",
	approveTraffickingFail: "APPROVE_TRAFFICKING_FAIL",
	resubmitTraffickingSuccess: "RESUBMIT_TRAFFICKING_SUCCESS",
	resubmitTraffickingFail: "RESUBMIT_TRAFFICKING_FAIL",
	getRecipientsSuccess: "GET_RECIPIENTS_SUCCESS",
	submitTraffickingRequestSuccess: "SUBMIT_TRAFFICKING_REQUEST_SUCCESS",
	submitTraffickingRequestRedirect: "SUBMIT_TRAFFICKING_REQUEST_REDIRECT",
	submitTraffickingRequestFail: "SUBMIT_TRAFFICKING_REQUEST_FAIL",
	mappingSuccess: "MAPPING_SUCCESS",
	mappingFail: "MAPPING_FAIL",
	getPlacementsToAddSuccess: "GET_PLACEMENTS_TO_ADD_SUCCESS",
	addPlacementsSuccess: "ADD_PLACEMENTS_SUCCESS",
	addPlacementsFail: "ADD_PLACEMENTS_FAIL",
	removePlacementsSuccess: "REMOVE_PLACEMENTS_SUCCESS",
	removePlacementsFail: "REMOVE_PLACEMENTS_FAIL",
	editTraffickingSuccess: "EDIT_TRAFFICKING_SUCCESS",
	editTraffickingFail: "EDIT_TRAFFICKING_FAIL",

	saveMasterCampaignFromBrief: "SAVE_MASTER_CAMPAIGN_FROM_BRIEF",
	draftCampaignSuccess: "DRAFT_CAMPAIGN_SUCCESS",
	draftCampaignFail: "DRAFT_CAMPAIGN_FAIL",

	getLandingPages: "GET_LANDING_PAGES",
	getPlacementAssignments: "GET_PLACEMENT_ASSIGNMENTS",
	insertUpdatePlacementSuccess: "INSERT_UPDATE_PLACEMENT_SUCCESS",
	insertUpdatePlacementFail: "INSERT_UPDATE_PLACEMENT_FAIL",

	getJiraTicketExistSuccess: "GET_JIRA_TICKET_EXIST_SUCCESS",
	getJiraTicketExistFail: "GET_JIRA_TICKET_EXIST_FAIL",
	getUserRole: "GET_USER_ROLE",
	setSelectedCampaigns: "SET_SELECTED_CAMPAIGNS",
	addCampaignToPrismaSuccess: "ADD_CAMPAIGN_TO_PRISMA_SUCCESS",
	addCampaignToPrismaFailure: "ADD_CAMPAIGN_TO_PRISMA_FAIL",
	addCampaignToDV360Success: "ADD_CAMPAIGN_TO_DV360_SUCCESS",
	addCampaignToDV360Failure: "ADD_CAMPAIGN_TO_DV360_FAIL",
	addCampaignToGCM: "ADD_CAMPAIGN_TO_GCM",
	fetchSyncStatusesSuccess: "FETCH_SYNC_STATUSES_SUCCESS",
	fetchSyncStatusesFailure: "FETCH_SYNC_STATUSES_FAILURE",
	updatePlacementPrismaStatus: "UPDATE_PLACEMENT_PRISMA_STATUS",
	getEnabledColumns: "GET_ENABLED_COLUMNS",
	setEnabledColumns: "SET_ENABLED_COLUMNS",
	lockUnlockCampaignBudgetSuccess: "LOCK_UNLOCK_CAMPAIGN_BUDGET_SUCCESS",
	lockUnlockCampaignBudgetFail: "LOCK_UNLOCK_CAMPAIGN_BUDGET_FAIL",
	lockUnlockWorkbookBudgetSuccess: "LOCK_UNLOCK_WORKBOOK_BUDGET_SUCCESS",
	lockUnlockWorkbookBudgetFail: "LOCK_UNLOCK_WORKBOOK_BUDGET_FAIL",

	trafficManagerToggled: "TRAFFIC_MANAGER_TOGGLED",

	sendPackagesToGCM: "SEND_PACKAGES_TO_GCM",
	postGCMFetchPackages: "POST_GCM_FETCH_PACKAGES",
	sendPlacementsToGCM: "SEND_PLACEMENTS_TO_GCM"
};
